module.exports = __webpack_public_path__ + "img/kiwi-bird.cb0ec3f5.svg";